import Controller from '@ember/controller';

export default class AuthenticatedProjectsShowSettingsController extends Controller {}
